module.exports = __webpack_public_path__ + "img/upload_ico.91976ed9.png";